module.exports = __webpack_public_path__ + "static/media/50010.4caf60ff.png";